const GetAppSettings = async (entity, id) => {
    let response = await fetch(`/api/settings?entity=${entity}&id=${id}`);

    if (response.status !== 200) {
        throw new Error("response status is not 200");
    }

    return response.json();
};

export default GetAppSettings;
